import { render, staticRenderFns } from "./BigNumbers.vue?vue&type=template&id=337872d6&"
import script from "./BigNumbers.vue?vue&type=script&lang=js&"
export * from "./BigNumbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports